import { IDocumentMetadata, DocumentMetadata, IFileInfo, NavigationStack } from '@/entities'
import { IDocumetUploadService } from './common.types'
import { http } from '@/shared/https'

export class DocumetUploadService implements IDocumetUploadService {

    /** service to upload new document */
    uploadDocument(files: any, schema: any, transactionId: any, language: string, multiple: boolean = false, menuId?: any): any {
        let formData = new FormData();

        if (multiple) {
            [...files].forEach(file => {
                formData.append(file.title || 'file', file, file.name); // currently only one file at a time
            });
        } else {
            formData.append("file", files);
            formData.append("FileName", files.name);
        }

        formData.append("DocCategoryId", "1");
        if (schema && schema.options) {
            formData.append("DocumentTagId", schema.options.docTag);
            formData.append("Language", language);
            formData.append("TransactionId", transactionId);

            if (menuId) {
                formData.append("MenuId", menuId);
            } else if (schema.options.menu) {
                formData.append("MenuId", schema.options.menu);
            }
        }

        return http.post('api/Documents', formData, 'multipart/form-data')
            .then((resp: any) => {
                if (resp.data.Result === 'OK') {
                    if (multiple) {
                        return resp.data.Record.DocumentStoreDetail.map((x) => {
                            return {
                                "name": x.FileName,
                                "documentId": x.DocumentStoreId,
                                "documentDetailId": x.DocumentStoreDetailId,
                                "uploadedFileName": x.UploadedName,
                                "title": x.Title
                            };
                        })
                    } else {
                        if (resp.data.Record.DocumentStoreDetail.length > 0) {
                            const file = resp.data.Record.DocumentStoreDetail[0];
                            return {
                                "name": file.FileName,
                                "documentId": file.DocumentStoreId,
                                "documentDetailId": file.DocumentStoreDetailId,
                                "uploadedFileName": file.UploadedName
                            }
                        }
                    }

                } else {
                    throw resp.data.Message;
                }
            });
    }

    updateMetadata(file: any): any {
        if (file.documentDetailId) {
            return http.put(`api/Documents/Metadata`, {
                DocumentStoreDetailId: file.documentDetailId,
                Title: file.title
            })
                .then((resp: any) => {
                    if (resp.data.Result === 'OK') {
                        return true;
                    }
                });
        }
    }

    /** service to remove the document  */
    removeDocument(file: any): any {
        if (file.documentId) {
            return http.delete(`api/Documents/${file.documentId}`)
                .then((resp: any) => {
                    if (resp.data.Result === 'OK') {
                        return true;
                    }
                });
        }
    }
    /** service to delete the document (doc store detail)  */
    deleteDocument(file: any): any {
        if (file.documentId) {
            return http.delete(`api/Documents/Detail/${file.documentDetailId}`)
                .then((resp: any) => {
                    if (resp.data.Result === 'OK') {
                        return true;
                    }
                });
        }

    }
    Notification() {
        return http.get(`api/Notification/NotficationInfo`)
            .then((resp: any) => {
                return resp.data;
            });
    }
    updateNotification(id, data) {
        return http.put(`api/Notification/NotficationInfoUpdate/${id}`, data).then((resp: any) => {
            if (resp.data.Result === 'OK') {
                return resp;
            } else {
                return {};
            }
        })
    }
    /** file download service */
    download(file: any) {
        if (file.documentId) {
            return http.getFile(`api/Documents/Download/${file.uploadedFileName}`, 'application/octet-stream')
                .then((resp: any) => {
                    const url = window.URL.createObjectURL(new Blob([resp.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', resp.headers["original-file"]);
                    document.body.appendChild(link);
                    link.click();
                    return true;
                });
        }
    }

    externalDownload(uploadedFileName: any) {
        http.getFile(`api/Documents/Download/${uploadedFileName}`, 'application/octet-stream')
            .then((resp: any) => {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', resp.headers["original-file"]);
                document.body.appendChild(link);
                link.click();
            });
    }

    /** Download and open the file in a dialog */
    openExternalFile(uploadedFileName: any) {
        return http.getFile(`api/Documents/Download/${uploadedFileName}`, 'application/octet-stream')
            .then((resp: any) => {
                const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.onclick = () => { window.open(url, 'popup', 'width=' + screen.availWidth + ',height=' + screen.availHeight) };
                document.body.appendChild(link);
                link.click();
                return true;
            });
    }


    /** list the docuements */
    listDocs(menuid: number, transId: number): any {
        return http.get(`api/Documents/${menuid}/Transaction/${transId}`)
            .then((resp: any) => {
                return resp.data;
            });
    }

    /** Get document tag by section */
    documentTagBySection(sections: Array<string>): any {
        if (sections) {
            return http.post('api/Common/DocumentTags', sections)
                .then((resp: any) => {
                    if (resp.data.Result === 'OK') {
                        return resp.data.Record;
                    }
                })
        }
    }

    /** Save the filter data in the application / review / grant */
    saveFilter(filterId: any, filter: string, count: number, mainMenuid: any, isChecked: boolean){ 
        var menuCheckBoxId = "";
        if (count == 0) {
            if(filterId != null && filter != null){
                let newFilterItem = filter + "=" + filterId;
                if (mainMenuid != null && mainMenuid.indexOf(newFilterItem) >= 0){
                    mainMenuid = mainMenuid.replace(newFilterItem, "");                    
                }
                else{ 
                    mainMenuid = newFilterItem; 
                } 
            } 
               
          count = count + 1;                
        } else {
        //Checking MainMenu already existing.
        menuCheckBoxId = filter + "=" + filterId;
        //Checking MainMenu already existing.
        if (mainMenuid.indexOf(menuCheckBoxId) >= 0) {
            mainMenuid = mainMenuid.replace(menuCheckBoxId, "");            
        } else {
            mainMenuid = mainMenuid + "&" + menuCheckBoxId;            
        }
            mainMenuid = mainMenuid.replace("?&", "?");
            mainMenuid = mainMenuid.replace("&&", "&");
            //Check first charector &
            var firstChar = mainMenuid.charAt(0);
            if (firstChar == "&") {
                mainMenuid = mainMenuid.substring(1);
            }
        }
        var lenghtString = mainMenuid.length - 1;
        var lastCharSting = mainMenuid.charAt(lenghtString);

        if (lastCharSting == "&") {
            mainMenuid = mainMenuid.substring(
                0,
                mainMenuid.length - 1
            );      
        }
    
        mainMenuid = this.saveToLocalStorage(filterId, filter, JSON.parse(localStorage.getItem('filterBy')), isChecked);
        return mainMenuid;
    }

    /** Add filter data to the local storage */
    saveToLocalStorage(checkBoxId, field, filterData, isChecked){    
        var filterByData = filterData; 
        var params = "";
        if(!isChecked)
        {
          const index = filterByData[field].indexOf(checkBoxId);
          filterByData[field].splice(index, 1);
          if(filterByData[field].length == 0) 
          {
            delete filterByData[field];        
          }   
        }
        else
        {
          if(checkBoxId != null && field != null)
          {
            if(filterByData.hasOwnProperty(field) && !filterByData[field].includes(checkBoxId))
              filterByData[field].push(checkBoxId);      
            else
              filterByData[field] = [checkBoxId];  
          }          
        } 
       
        localStorage.setItem('filterBy', JSON.stringify(filterByData));
        
        Object.keys(filterByData).forEach(key => {
            let val = filterByData[key];
            if(val.length > 0)
            {
                val.map((x) => {
                        params = params == "" ? key + "=" + x : (params + "&" + key + "=" + x);
                    });                    
            }
        });
        
        return params;
      }
      
    /** Get the filter data from local storage */
    filtertoQuery(fields: Array<string>): string {        
        var params = "";
        var localVal = localStorage.getItem('filterBy');        
        if(localVal != "{}")
        {
          var filterLst = JSON.parse(localVal);
          var fieldObj = JSON.stringify(fields);
          Object.keys(filterLst).forEach(key => {
            let val = filterLst[key];
            if(val.length > 0 && fieldObj.includes(key))
            {
                val.map((x) => {
                        params = params == "" ? key + "=" + x : (params + "&" + key + "=" + x);
                    });                    
            }
        }); 
          return params;
        }        
    }
    
    /** Checked wether filter applied */
    filterApplied(field: string, id: number): boolean {
        let flag = false;
        var filterData = JSON.parse(localStorage.getItem('filterBy'));
        if(filterData.hasOwnProperty(field) && filterData[field].includes(id) && id != null && field != null){
            flag = true;      
        }
    
        return flag; 
    }
} 